import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ad24bc0c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ad24bc0c&prod&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=ad24bc0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad24bc0c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Coupons: require('/app/components/coupons/coupons.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default})
